// ✅ MODIFICATION MISE À JOUR 11: Remplacer user-details-popup.component.ts

import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';

export interface UserDetailsInput {
  // Pas d'input spécifique nécessaire
}

export interface UserDetailsResult {
  firstName: string;
  lastName: string;
}

@Component({
  selector: 'app-user-details-popup',
  templateUrl: './user-details-popup.component.html',
  styleUrls: ['./user-details-popup.component.scss']
})
export class UserDetailsPopupComponent implements OnInit, IDialogContentComponent<UserDetailsResult, UserDetailsInput> {
  input?: UserDetailsInput;
  userDetailsForm: FormGroup;

  constructor(private readonly formBuilder: FormBuilder) {
    this.userDetailsForm = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]]
    });
  }

  ngOnInit(): void {
    // Méthode requise par l'interface
  }

  getResult(): UserDetailsResult {
    return {
      firstName: this.userDetailsForm.value.firstName?.trim() || '',
      lastName: this.userDetailsForm.value.lastName?.trim() || ''
    };
  }

  isDisabled(): boolean {
    return !this.userDetailsForm.valid;
  }

  get firstNameControl() {
    return this.userDetailsForm.get('firstName');
  }

  get lastNameControl() {
    return this.userDetailsForm.get('lastName');
  }

  get firstNameErrorText(): string {
    const control = this.firstNameControl;
    if (control?.hasError('required')) {
      return 'Le prénom est obligatoire';
    }

    if (control?.hasError('minlength')) {
      return 'Le prénom doit contenir au moins 2 caractères';
    }

    if (control?.hasError('maxlength')) {
      return 'Le prénom ne peut pas dépasser 50 caractères';
    }

    return '';
  }

  get lastNameErrorText(): string {
    const control = this.lastNameControl;
    if (control?.hasError('required')) {
      return 'Le nom est obligatoire';
    }

    if (control?.hasError('minlength')) {
      return 'Le nom doit contenir au moins 2 caractères';
    }

    if (control?.hasError('maxlength')) {
      return 'Le nom ne peut pas dépasser 50 caractères';
    }

    return '';
  }
}
